import { hashTestIdValue } from '@lucidlink/uicore/interactions';
export const GuestsTableTestIdFactory = {
    getGuestsTableEmptyStateTestId: () => 'guests-table-empty-state',
    getGuestsTableEmptyStateIconTestId: () => 'guests-table-empty-state-icon',
    getGuestsEmptyStateCreateGuestLinkTestId: () => 'guests-empty-state-create-guest-link',
    getGuestRowTestId: (email) => ['guest', hashTestIdValue(email)].join('-'),
    getGuestAvatarTestId: (email) => ['guest-avatar', hashTestIdValue(email)].join('-'),
    getGuestLinksCountTestId: () => 'guest-links-count',
    getGuestLastLoginTestId: () => 'guest-last-login',
    getGuestNeverLoggedInTestId: () => 'guest-never-logged-in',
    getGuestsTableTestId: () => 'guests',
    getGuestMenuTestId: () => 'guest-menu',
    getGuestMenuTriggerTestId: (email) => ['guest-menu-trigger', hashTestIdValue(email)].join('-'),
    getViewGuestLinksTestId: () => 'view-guest-links',
    getRemoveFromAllLinksTestId: () => 'remove-from-all-links',
    getRemoveFromAllLinksGuestAvatarTestId: () => 'remove-from-all-links-guest-avatar',
};
